import {CellStyle} from '../../file/message/CellStyle';

export class ProcessorField {
arrayMode: boolean | null;
children: ProcessorField[];
code: string;
contextData: boolean;
contextDataKind: string;
defaultValue: string;
label: string;
length: string;
parentCode: string;
parentTableName: string;
style: CellStyle;
tableName: string;
type: string;
way: string;
}

